import { Component, Vue } from "vue-property-decorator";
import { GET_MAINTENANCE, SAVE_MAINTENANCE } from "../../../api/account"

import DatePicker from 'vue2-datepicker';
import moment from 'moment';
// import Model from "@/models/Model";
// import VModal from 'vue-js-modal'

import 'vue2-datepicker/index.css';


// import { Component, Vue } from "vue-property-decorator";
// import DatePicker from 'vue2-datepicker';
// import moment from 'moment';
// import Model from "@/models/Model";
// import VModal from 'vue-js-modal'
// import vSelect from 'vue-select';

// import 'vue2-datepicker/index.css';
// import VueTimepicker from 'vue2-timepicker'

// import 'vue-select/dist/vue-select.css';
// import 'vue2-timepicker/dist/VueTimepicker.css'

@Component({
    components: {
        DatePicker
    },
    filters: {
        currency(value: any) {
            const val = (value / 1).toFixed(2).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        dateTime(val: any) {
            return val ? moment(val).local().format('DD-MM-YYYY HH:mm:ss') : ''
        }
    }
})

default class Maintenance extends Vue {

    private canDisplayUatMaintenanceButton = process.env.NODE_ENV == 'develop'
    
    private dataStore = {
        server: '',
        status: false,
        maintenanceDateTime: new Date(),
        descriptionTH: "",
        descriptionEN: ""
    }

    private maintenanceResult

    private styleLoader = {
        color: '#CFA137',
        loader: 'spinner',
        width: 145,
        height: 235,
        backgroundColor: '#000000',
        opacity: 0.5,
    }

    async mounted() {
        console.log(process.env.NODE_ENV)
        console.log(this.canDisplayUatMaintenanceButton)
        const loader = this.$loading.show(this.styleLoader)
        await this.getLastMaintenance()
        loader.hide()
    }

    public async getLastMaintenance(){
        const maintenanceResult = await GET_MAINTENANCE()
        if(maintenanceResult["data"]){
            this.dataStore.status = maintenanceResult.data.status
            this.dataStore.descriptionTH = maintenanceResult.data.descriptionTH
            this.dataStore.descriptionEN = maintenanceResult.data.descriptionEN
            this.dataStore.maintenanceDateTime = new Date(maintenanceResult.data.updatedDate)
        }
    }

    public setMaintenanceVal( status: boolean){
        this.dataStore.status = status
    }
    
    public async saveMaintenance(server: string){
        this.dataStore.server = server
        this.$swal({
            title: `${this.$t('MANAGEMENT.WANT_ADD_DATA').toString()}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#CFA137',
            confirmButtonText: `<span style='color: white;'>${this.$t('CONFIRM').toString()}</span>`,
            cancelButtonColor: '#FF0000',
            cancelButtonText: `<span style='color: white;'>${this.$t('CANCEL').toString()}</span>`,
        }).then(async (result) => {
            if (!result.isConfirmed) {
                return
            }
            const loader = this.$loading.show(this.styleLoader)
            const resultSaveMaintenance = await SAVE_MAINTENANCE(this.dataStore)
            if (!resultSaveMaintenance.success) {
                this.$swal({
                    text: resultSaveMaintenance.error.message, // `${this.$t('MANAGEMENT.NOT_USE_USERNAME').toString()}`,
                    icon: "error",
                    confirmButtonColor: '#CFA137',
                    confirmButtonText: `<span style='color: white;'>${this.$t('OK').toString()}</span>`
                });
                loader.hide()
                return
            }
            this.$swal({
                text: 'save success', 
                icon: "success",
                timer: 3000,
                showConfirmButton: false,
                timerProgressBar: true,
            });
            loader.hide()
        })
    }
}
export default Maintenance